import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/Login'
import Home from '@/Home'
import { getToken } from '@/utils/auth' // getToken from cookie

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (getToken()) {
          next({ path: '/home' })
          //next()
        }else{
          next()
        }
      }
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (getToken()) {
          next()
        }else{
          next({ path: '/' })
        }
      }
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/routers.js